var process = (typeof require != "undefined") ? require("process") : false;
var exec = (typeof require != "undefined") ? require('child_process').exec : false;
var gui = (typeof require != "undefined") ? require('nw.gui') : false;
var fs = (typeof require != "undefined") ? require('fs') : false;
var path = (typeof require != "undefined") ? require('path') : false;

// Constructor
function Pommes() {
	this.data = {};
	this.lastClick = millis();
	this.resetDelay = 30000;
	this.previewAnimated = false;
	this.touchEvent = "mousedown touchstart";

	this.currentLibraryIndex = 0;

	// Password properties
	this.validPassword = "4353";
	this.currentPassword = "";

	// this.printerName = "HP LaserJet P1005";
	// this.printerName = "Epson TM-T88V Receipt";
	this.printerName = "Dell C2660dn Color Laser";
	this.printerTray = "Bac 1";
	this.printerPaperSize = 185;
	this.filepath = "";

	// Editor settings
	this.editor = {
		scale: 1,
		offsetX: 0.0,
		offsetY: 0.0,
	};

	// Init game
	this.init();

	// Init audio
	this.audio = new Audio();
	$("body").append(this.audio.createDOM());

	// Init camera
	this.camera = new Camera(this);

	// Init file generator
	this.generator = new Generator(this);


}

Pommes.prototype.init = function () {

	setInterval($.proxy(function () {
		this.initEvents();
	}, this), 5000);

	// Go to first screen
	this.goToScreen("screen-1");

	// Timeout related
	$(document).on("click", $.proxy(function (e) {
		this.resetTimer();
	}, this));
	setInterval($.proxy(function (e) {
		this.checkTimer();
	}, this), 1000);
}


Pommes.prototype.initEvents = function() {

	// Record
	$("#record-button").off(this.touchEvent).on(this.touchEvent, $.proxy(function (e) {
		e.preventDefault();
		this.recordClick();
	}, this));

	// Zoom-in
	$("#zoom-in").off(this.touchEvent).on(this.touchEvent, $.proxy(function (e) {
		e.preventDefault();
		this.editor.scale += 0.1
		this.applyEditorSettingsToPreview();
	}, this));

	// Zoom-out
	$("#zoom-out").off(this.touchEvent).on(this.touchEvent, $.proxy(function (e) {
		e.preventDefault();
		this.editor.scale -= 0.1;
		this.applyEditorSettingsToPreview();
	}, this));

	// Drag
	$("#drag-area").off('touchstart').on('touchstart', function (e) {
		e.preventDefault();

		var swipe = e.originalEvent.touches,
			start = {
				x: swipe[0].pageX,
				y: swipe[0].pageY
			},
			original = {
				x: app.editor.offsetX,
				y: app.editor.offsetY,
			};

		$(this).on('touchmove', function (e) {

			var contact = e.originalEvent.touches;
			var distance = {
				x: contact[0].pageX - start.x,
				y: contact[0].pageY - start.y,
			};

			app.editor.offsetX = original.x + distance.x;
			app.editor.offsetY = original.y + distance.y;
			app.applyEditorSettingsToPreview();

		}).one('touchend', function () {
			$(this).off('touchmove touchend');
		});

	}).off('tap').on('tap', function (e) {
		e.preventDefault();

		$(this).trigger('click');
	});

	// Next
	$("#next").off(this.touchEvent).on(this.touchEvent, $.proxy(function (e) {
		e.preventDefault();
		this.createImage();
		this.goToScreen("screen-2");
	}, this));

	// Prev
	$("#prev").off(this.touchEvent).on(this.touchEvent, $.proxy(function (e) {
		e.preventDefault();
		this.goToScreen("screen-1");
	}, this));

	// Pommes
	$(".pommes-library-item").off(this.touchEvent).on(this.touchEvent, $.proxy(function (e) {
		e.preventDefault();
		var id = $(e.currentTarget).attr("id").toString().substr(-1, 1);
		this.selectLibraryItem(id)
	}, this));

	// Keyboard key
	$(".keyboard-key").off(this.touchEvent).on(this.touchEvent, $.proxy(function (e) {
		e.preventDefault();
		var val = $(e.currentTarget).data("keyvalue").toString()
		this.currentPassword += val;
		if (this.currentPassword.length >= this.validPassword.length) {
			this.validatePassword();
		}
	}, this));

	if (gui) {
		$(window).off("keydown").on('keydown', $.proxy(function (e) {
			this.keyPressed(e)
		}, this));
	}
}


Pommes.prototype.keyPressed = function (e) {

	if (e.keyCode == 27) {
		// Escape
		gui.App.quit();
	} else if (e.keyCode == 73 || e.keyCode == 67) {
		// Key I or C
		gui.Window.get().showDevTools();
	}
}


// Animate between screens
Pommes.prototype.goToScreen = function (screenId) {

	console.log("goToScreen", screenId)

	var reverse = (screenId == "screen-1") ? -1 : 1;

	// Hide current
	$(".screen.current").addClass("disabled");
	TweenMax.fromTo(".screen.current", 0.4, {
		autoAlpha: 1,
		x: 0,
	}, {
		autoAlpha: 0,
		x: -50 * reverse,
		onComplete: function () {
			$(this.target).removeClass("current");
		},
	});

	// Show new
	TweenMax.fromTo("#" + screenId, 0.4, {
		autoAlpha: 0,
		x: 50 * reverse,
	}, {
		autoAlpha: 1,
		x: 0,
		delay: 0.4,
		onComplete: function () {
			$(this.target).addClass("current");
			$(this.target).removeClass("disabled");
		},
	});

	if (screenId == "screen-2") {
		$("#validated-checkmark").addClass("hidden");
		TweenMax.to($("#keyboard"), 0.1, {
			scale: 1,
			autoAlpha: 1,
			delay: 0.5
		});
	}
};

Pommes.prototype.recordClick = function () {
	this.camera.snapshot();
}

// Callback when a new picture is taken
Pommes.prototype.pictureTaken = function (rawBody) {

	// Flash animation
	TweenMax.fromTo($(".flash"), 0.4, {
		autoAlpha: 1,
	}, {
		autoAlpha: 0,
	});


	// Reset editor settings
	this.resetEditor();

	// Add to library
	this.addToLibrary();
}

// Add to library
Pommes.prototype.addToLibrary = function () {

	var id = this.currentLibraryIndex;

	$(".pommes-library-item").each(function (i, n) {

		if ($(n).attr("id") == "pommes-library-" + id) {
			// Current id
			$(n).removeClass("hidden").alterClass('position-*').addClass("position-0 active").data("position", 0);

		} else if (!$(n).hasClass("hidden")) {
			// Go through others
			var newPosition = parseInt($(n).data("position")) + 1;
			$(n).alterClass('position-*').addClass("position-" + newPosition).removeClass("active").data("position", newPosition);
			// Handle last one
			if (newPosition == 4) {
				$(n).addClass("hidden");
				setTimeout($.proxy(function (n) {
					$(n).alterClass('position-*').addClass("position-0");
				}, this, n))
			}
		}
	});

	// Save source to image
	$("#pommes-library-" + id + "-image").attr("src", $("#camera-image-receiver").attr("src"));

	// Increment library index
	this.currentLibraryIndex = (this.currentLibraryIndex + 1) % 5;
}

// Select library item
Pommes.prototype.selectLibraryItem = function (id) {

	// Reset editor settings
	this.resetEditor();

	// Select new item
	$(".pommes-library-item").removeClass("active");
	$("#pommes-library-" + id).addClass("active");

	// Copy image data to main image
	$("#camera-image-receiver").attr("src", $("#pommes-library-" + id + "-image").attr("src"));

}

// Create image with baked editor settings
Pommes.prototype.createImage = function () {

	// Create image from camera image receiver
	var img = $("#camera-image-receiver").get(0);
	this.generator.create(img, this.editor);

	this.generator.save(img, 'file-to-print.png', $.proxy(function (filePath) {
		this.filepath = filePath;
	}, this));
}

// Apply offset and zoom to preview
Pommes.prototype.applyEditorSettingsToPreview = function () {

	// Constain values
	this.constrainEditorSettings()

	// Container size
	var cw = $("#main-image").width();
	var ch = $("#main-image").height();

	// Image size
	var sw = this.camera.canvasResolution.width
	var sh = this.camera.canvasResolution.height;

	// Calculate ratio
	var ratio = ch / sh;

	// Caluclate new size
	var size = ratio * sh * this.editor.scale;

	$("#camera-image-receiver").height(size);
	$("#camera-image-receiver").css("margin-left", (cw - size) / 2);
	$("#camera-image-receiver").css("margin-top", (ch - size) / 2);
	$("#camera-image-receiver").css("left", ratio * this.editor.offsetX);
	$("#camera-image-receiver").css("top", ratio * this.editor.offsetY);
}

// Validate an input password
Pommes.prototype.validatePassword = function () {

	if (this.currentPassword == this.validPassword) {

		// Valid password !
		console.log("password valid")

		// Launch print
		this.print();

		TweenMax.to("#keyboard", 0.25, {
			autoAlpha: 0,
			scale: 0.8,
			onComplete: function () {
				$("#validated-checkmark").removeClass("hidden");
			},
		});
	} else {

		// Invalid password
		console.log("password invalid")

		$("#keyboard-wrapper").addClass('invalid');
		setTimeout($.proxy(function () {
			$("#keyboard-wrapper").removeClass('invalid');
			this.currentPassword = "";

		}, this), 500);
	}

	this.currentPassword = "";
}

// Print file
Pommes.prototype.print = function () {

	var filename = this.filepath;
	var copies = 1;
	var printerName = this.printerName;
	var printerTray = this.printerTray;
	var printerPaperSize = this.printerPaperSize;

	if (process) {

		// Log platforrm
		// console.log(process.platform);

		if (process.platform == 'darwin') {

			nw.Window.open("file://" + filename, {show: false}, function (win) {

				win.on('loaded', function () {

					console.log("print here")

					win.print({
						printer: this.printer,
						headerFooterEnabled: false
					});

					win.close();
					// nw.Shell.openItem(xxx);
				});
			});


			// printer.printFile({
			// 	filename: "data/" + filename,
			// 	printer: process.env[3], // printer name, if missing then will print to default printer
			// 	success: function (jobID) {
			// 		console.log("sent to printer with ID: " + jobID);
			// 	},
			// 	error: function (err) {
			// 		console.log(err);
			// 	}
			// });

		} else {

			// executes `pwd`
			// var cmd = '2printer -alerts_no -s \"' + process.cwd() + '/data/' + filename + '"';
			var cmd = '2printer -alerts_no -s \"' + filename + '"';

			// Add printer name
			if (typeof printerName != "undefined" && printerName != "") {
				cmd += ' -prn "' + printerName + '"';
			}

			// Add copies count
			if (typeof filename != "undefined") {
				cmd += ' -copies ' + parseInt(copies);
			}

			// Add printer tray name
			if (typeof printerTray != "undefined" && printerTray != "") {
				cmd += ' -tray "' + printerTray + '"';
			}

			// Add printer tray name
			if (typeof printerPaperSize != "undefined" && printerPaperSize != "") {
				cmd += ' -papersize ' + printerPaperSize;
			}

			console.log("EXECUTE: " + cmd);
			var child = exec(cmd, function (error, stdout, stderr) {
				console.log('stdout: ' + stdout);
				console.log('stderr: ' + stderr);
				if (error !== null) {
					console.log('exec error: ' + error);
				}
			});
		}
	}
};

// Reset editor (drag) settings
Pommes.prototype.resetEditor = function (rawBody) {
	this.editor.scale = 1;
	this.editor.offsetX = 0;
	this.editor.offsetY = 0;
	this.applyEditorSettingsToPreview();
}

// Constrait this.editor settings so their values are always valid
Pommes.prototype.constrainEditorSettings = function () {

	// Define required parameters
	var sw = this.camera.canvasResolution.width * this.editor.scale
	var sh = this.camera.canvasResolution.height * this.editor.scale;
	var dw = this.generator.canvas.width;
	var dh = this.generator.canvas.height;

	// Define min and max
	var minOffsetX = -Math.abs(sw - dw) / 2;
	var maxOffsetX = -minOffsetX;
	var minOffsetY = -Math.abs(sh - dh) / 2;
	var maxOffsetY = -minOffsetY;

	// Apply constrain
	this.editor.offsetX = constrain(this.editor.offsetX, minOffsetX, maxOffsetX)
	this.editor.offsetY = constrain(this.editor.offsetY, minOffsetY, maxOffsetY)
	this.editor.scale = constrain(this.editor.scale, 1, 5)
}


// Reset timer
Pommes.prototype.resetTimer = function (data) {
	this.lastClick = millis();
}

// Check timer
Pommes.prototype.checkTimer = function (data) {
	var noActionSince = millis() - this.lastClick;
	if (noActionSince > this.resetDelay) {
		this.reset();
	}
}

// Reset
Pommes.prototype.reset = function () {
	this.lastClick = millis();
	// TODO create reset mecanic
	// this.clearInvoice();
};

// Expose Pommes
window.Pommes = Pommes;